import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Route, useHistory, Switch } from "react-router-dom";
import { getSession } from "../src/utilities/Crypto";

import AppTopbar from "./AppTopbar";
import AppFooter from "./AppFooter";
// import AppConfig from "./AppConfig";
import AppMenu from "./AppMenu";
import AppBreadcrumb from "./AppBreadcrumb";
import AppInlineProfile from "./AppInlineProfile";
import { Dashboard } from "./components/Dashboard";
import NotFound from "./pages/NotFound";
//Tmp
import Main from "./pages/Main";

//000
import P003 from "./pages/000/003/P003";

//100
import P100 from "./pages/100/100/P100";
import P101 from "./pages/100/101/P101";
import P102 from "./pages/100/102/P102";
import P103 from "./pages/100/103/P103";
import P104 from "./pages/100/104/P104";
import P105 from "./pages/100/105/P105";
import P106 from "./pages/100/106/P106";
import P107 from "./pages/100/107/P107";
import P108 from "./pages/100/108/P108";
import P109 from "./pages/100/109/P109";
import P110 from "./pages/100/110/P110";
import P111 from "./pages/100/111/P111";
import P115 from "./pages/100/115/P115";
import P120 from "./pages/100/120/P120";

//200
import P200 from "./pages/200/200/P200";
import P201 from "./pages/200/201/P201";
import P202 from "./pages/200/202/P202";
import P203 from "./pages/200/203/P203";
import P204 from "./pages/200/204/P204";
import P205 from "./pages/200/205/P205";
import P206 from "./pages/200/206/P206";
import P207 from "./pages/200/207/P207";
import P208 from "./pages/200/208/P208";
import P210 from "./pages/200/210/P210";
import P211 from "./pages/200/211/P211";
import P214 from "./pages/200/214/P214";
import P215 from "./pages/200/215/P215";
import P216 from "./pages/200/216/P216";
import P216Edit from "./pages/200/216/P216Edit";
import P218 from "./pages/200/218/P218";
import P220 from "./pages/200/220/P220";
import P221 from "./pages/200/221/P221";
import P230 from "./pages/200/230/P230";
import P231 from "./pages/200/231/P231";
import P233 from "./pages/200/233/P233";
import P233Edit_1 from "./pages/200/233/P233Edit_1";
import P233Edit_2 from "./pages/200/233/P233Edit_2";
import P240 from "./pages/200/240/P240";
import P241 from "./pages/200/241/P241";
import P242 from "./pages/200/242/P242";
import P243 from "./pages/200/243/P243";
import P244 from "./pages/200/244/P244";
import P250 from "./pages/200/250/P250";
import P260 from "./pages/200/260/P260";

//300
import P300 from "./pages/300/300/P300";
import P301 from "./pages/300/301/P301";
import P302 from "./pages/300/302/P302";
import P303 from "./pages/300/303/P303";
import P350 from "./pages/300/350/P350";

//400
import P400 from "./pages/400/400/P400";
import P401 from "./pages/400/401/P401";
import P402 from "./pages/400/402/P402";
import P404 from "./pages/400/404/P404";
import P405 from "./pages/400/405/P405";
import P410 from "./pages/400/410/P410";
import P411 from "./pages/400/411/P411";
import P412 from "./pages/400/412/P412";
import P419 from "./pages/400/419/P419";
import P420 from "./pages/400/420/P420";
import P421 from "./pages/400/421/P421";

import PCIA from "./pages/CIA/PCIA";

import PrimeReact from "primereact/api";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";
import "./App.css";
import "./OverView.css";
import "../src/components/HandsonTable/handsontable.css";
import { dataUserSession } from "./utilities/dataSession";

const App = () => {
    const [menuActive, setMenuActive] = useState(false);
    const [menuMode, setMenuMode] = useState("horizontal");
    const [darkMenu, setDarkMenu] = useState(true);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [inlineMenuActive, setInlineMenuActive] = useState(false);
    const [profileMode, setProfileMode] = useState("popup");
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(false);
    const history = useHistory();
    const [routersList, setRoutersList] = useState([]);

    useEffect(() => {
        // console.log()
        if (dataUserSession()) {
            let userRole = dataUserSession().userRole;
            let userBranchCode = dataUserSession().userBranchCode;
            if (userRole) {
                settingMenu(userRole, userBranchCode);
            }
        } else {
            history.push("/login");
        }
    }, []);

    let menuClick = false;
    let configClick = false;
    let topbarItemClick = false;
    let inlineMenuClick = false;

    // const menu = [
    //     {
    //         label: "[100] ผู้รับเหมา",
    //         icon: "pi pi-fw pi-clone",
    //         items: [{ label: "[100] Dashboard", icon: "pi pi-fw pi-pencil", to: "/100" }],
    //     },
    //     {
    //         label: "[200] ผู้คุมงาน",
    //         icon: "pi pi-fw pi-clone",
    //         items: [{ label: "[200] Dashboard", icon: "pi pi-fw pi-pencil", to: "/200" }],
    //     },
    //     {
    //         label: "[300] ผู้บริหาร",
    //         icon: "pi pi-fw pi-clone",
    //         items: [{ label: "[300] Dashboard", icon: "pi pi-fw pi-pencil", to: "/300" }],
    //     },
    //     {
    //         label: "[400] ผู้ดูแลระบบ",
    //         icon: "pi pi-fw pi-clone",
    //         items: [
    //             { label: "[400] Dashboard ผู้ดูแลระบบ", icon: "pi pi-fw pi-pencil", to: "/400" },
    //             // { label: "[402] บริษัทคู่สัญญา", icon: "pi pi-fw pi-pencil", to: "/402" },
    //             { label: "[404] ลักษณะงาน", icon: "pi pi-fw pi-pencil", to: "/404" },
    //             // { label: "[405] งานสั่งการเฉพาะอย่าง", icon: "pi pi-fw pi-pencil", to: "/405" },
    //         ],
    //     },
    // ];
    const route0XX = [{ path: "/003", component: P003, meta: { breadcrumb: [{ parent: "ข้อมูลผู้ใช้งาน", label: "ข้อมูลผู้ใช้งาน", page: "/003" }] } }];

    const route1XX = [
        { path: "/100", component: P100, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "Dashboard ผู้รับเหมา", page: "/100" }] } },
        { path: "/101", component: P101, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "เพิ่มใบแจ้งฯ", page: "/101" }] } },
        { path: "/102", component: P102, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "ใบแจ้งฯ (งานใหม่)", page: "/102" }] } },
        { path: "/103", component: P103, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "แสดงรายการงานสั่งการเฉพาะอย่าง", page: "/103" }] } },
        { path: "/104", component: P104, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "ใบแจ้งฯ (งานสั่งการเฉพาะอย่าง)", page: "/104" }] } },
        { path: "/105", component: P105, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "รายงานผลงานประจำวัน (งานใหม่) ", page: "/105" }] } },
        { path: "/106", component: P106, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "รายงานผลงานประจำวัน (งานสั่งการเฉพาะอย่าง)", page: "/106" }] } },
        { path: "/107", component: P107, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "แสดงงานสั่งการเฉพาะอย่างคงค้าง", page: "/107" }] } },
        { path: "/108", component: P108, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "ค้นหาใบแจ้งฯ", page: "/108" }] } },
        { path: "/109", component: P109, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "รายละเอียดสัญญา/เส้นทางของผู้รับเหมา", page: "/109" }] } },
        { path: "/110", component: P110, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "การประมาณการเบิกจ่าย/ความก้าวหน้าโครงการ", page: "/110" }] } },
        { path: "/111", component: P111, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "ค้นหางานสั่งการเฉพาะอย่าง", page: "/111" }] } },
        { path: "/115", component: P115, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "รายละเอียดสัญญา", page: "/115" }] } },
        { path: "/120", component: P120, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "ประวัติใบแจ้งฯ", page: "/120" }] } },
    ];

    const route2XX = [
        { path: "/200", component: P200, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "DashBoard ผู้คุมงาน", page: "/200" }] } },
        { path: "/201", component: P201, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "บันทึกอนุมัติ/ไม่อนุมัติ งานใหม่", page: "/201" }] } },
        { path: "/202", component: P202, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "บันทึกอนุมัติ/ไม่อนุมัติ ใบแจ้งฯงานสั่งการเฉพาะอย่าง", page: "/202" }] } },
        { path: "/203", component: P203, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "อนุมัติการรายงานผล - งานใหม่", page: "/203" }] } },
        { path: "/204", component: P204, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "อนุมัติการรายงานผล - งานสั่งการเฉพาะอย่าง", page: "/204" }] } },
        { path: "/205", component: P205, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ค้นหาใบแจ้งฯ", page: "/205" }] } },
        { path: "/206", component: P206, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "บันทึกผลการตรวจงาน", page: "/206" }] } },
        { path: "/207", component: P207, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "เพิ่มการสั่งการเฉพาะอย่าง", page: "/207" }] } },
        { path: "/208", component: P208, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "รายละเอียดสัญญา/เส้นทาง", page: "/208" }] } },
        { path: "/210", component: P210, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "รายงานสรุปผลการก่อสร้างรายสัปดาห์/รายเดือน", page: "/210" }] } },
        { path: "/211", component: P211, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "สรุปค่างาน", page: "/211" }] } },
        { path: "/212", component: P211, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ประมาณการ-แยกรายการ", page: "/212" }] } },
        { path: "/213", component: P211, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "กระดาษทด-รวม", page: "/213" }] } },
        { path: "/214", component: P214, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "กระดาษทด-เส้นทาง", page: "/214" }] } },
        { path: "/215", component: P214, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "บันทึกผลฯ-เส้นทาง", page: "/215" }] } },
        { path: "/216", component: P216, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ใบแจ้งเตือน", page: "/216" }] } },
        { path: "/216Edit", component: P216Edit, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ใบแจ้งเตือน", page: "/216" }] } },
        { path: "/218", component: P218, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "รายงานการเบิกว้สดุ/อุปกรณ์", page: "/218" }] } },
        { path: "/220", component: P220, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ตรวจรับ", page: "/220" }] } },
        { path: "/221", component: P221, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "รายละเอียดการส่งงาน (P1)", page: "/221" }] } },
        { path: "/230", component: P230, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: " P1", page: "/230" }] } },
        { path: "/231", component: P231, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: " P1-รายละเอียด", page: "/231" }] } },
        { path: "/233", component: P233, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: " P2 ขอเบิกจ่ายเงิน", page: "/233" }] } },
        { path: "/233Edit_1", component: P233Edit_1, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: " P2  ", page: "/233" }] } },
        { path: "/233Edit_2", component: P233Edit_2, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: " P2  ", page: "/233" }] } },
        { path: "/240", component: P240, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ประเมิน 3 มิติ", page: "/240" }] } },
        { path: "/241", component: P241, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "แสดงรายการประเมินของสัญญา", page: "/241" }] } },
        { path: "/242", component: P242, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "รายละเอียดและผลการประเมิน (แบบประเมินที่ 1)", page: "/242" }] } },
        { path: "/243", component: P243, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "คะแนนการประเมิน (แบบประเมินที่ 1)", page: "/243" }] } },
        { path: "/244", component: P244, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ข้อมูลประกอบการประเมิน แบบประเมินที่ 1", page: "/244" }] } },
        { path: "/250", component: P250, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "งานสั่งการเฉพาะอย่าง", page: "/250" }] } },
        { path: "/260", component: P260, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ประวัติใบแจ้งฯ", page: "/260" }] } },
    ];

    const route3XX = [
        { path: "/301", component: P301, meta: { breadcrumb: [{ parent: "ผู้บริหารสาขา", label: "Dashboard ผู้บริหารสาขา", page: "/301" }] } },
        { path: "/302", component: P302, meta: { breadcrumb: [{ parent: "ผู้บริหารสาขา", label: "รายละเอียดสัญญา", page: "/302" }] } },
        { path: "/303", component: P303, meta: { breadcrumb: [{ parent: "ผู้บริหารสาขา", label: "ข้อมูลสรุปผู้ควบคุมงาน", page: "/303" }] } },
        { path: "/350", component: P350, meta: { breadcrumb: [{ parent: "Dashboard", label: "Dashboard ผู้กรรมการ/ผู้ตรวจสอบ", page: "/350" }] } },
    ];

    const route4XX = [
        { path: "/400", component: P400, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "Dashboard ผู้ดูแลระบบ", page: "/400" }] } },
        { path: "/401", component: P401, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ผู้ใช้งาน", page: "/401" }] } },
        { path: "/402", component: P402, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "บริษัทคู่สัญญา", page: "/402" }] } },
        { path: "/411", component: P411, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "สัญญา", page: "/411" }] } },
        { path: "/419", component: P419, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ลงแนวเส้นท่อบน GIS", page: "/419" }] } },
        { path: "/412", component: P412, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "รายละเอียดสัญญา", page: "/412" }] } },
        { path: "/420", component: P420, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "เฉดสีแสดงความก้าวหน้าของงานบน GIS", page: "/420" }] } },
        { path: "/421", component: P421, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ข้อมูลกล้อง CIA", page: "/421"}]}},
        { path: "/CIA", component: PCIA , meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ข้อมูลกล้องจากระบบ CIA", page: "/CIA"}]}},
    ];

    const route4XXA = [
        { path: "/404", component: P404, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ลักษณะงาน", page: "/404" }] } },
        { path: "/405", component: P405, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "งานสั่งการเฉพาะอย่าง", page: "/405" }] } },
        { path: "/410", component: P410, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "กำหนดหัวข้อหลักเกณฑ์การประเมิน", page: "/410" }] } },
    ];

    const settingMenu = (userRole, userBranchCode) => {
        // console.log(userRole, userBranchCode);
        // let menuList  = []
        let menuList = [...route0XX];
        if (userRole === "1") {
            menuList.unshift({ path: "/", component: P100, exact: true, meta: { breadcrumb: [{ parent: "ผู้รับเหมา", label: "Dashboard ผู้รับเหมา", page: "/100" }] } });
            menuList = [...menuList, ...route1XX];
        } else if (userRole === "2") {
            menuList.unshift({ path: "/", component: P200, exact: true, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "Dashboard ผู้คุมงาน", page: "/200" }] } });
            menuList.push({ path: "/419", component: P419, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "ลงแนวเส้นท่อบน GIS", page: "/419" }] } });
            menuList = [...menuList, ...route2XX];
        } else if (userRole === "3") {
            menuList.unshift({ path: "/", component: P301, exact: true, meta: { breadcrumb: [{ parent: "ผู้บริหารสาขา", label: "Dashboard ผู้บริหารสาขา", page: "/301" }] } });
            menuList = [...menuList, ...route1XX, ...route3XX];
        } else if (userRole === "4") {
            menuList.unshift({ path: "/", component: P300, exact: true, meta: { breadcrumb: [{ parent: "ผู้บริหาร", label: "Dashboard ผู้บริหาร", page: "/300" }] } });
            menuList.push({ path: "/300", component: P300, meta: { breadcrumb: [{ parent: "ผู้บริหาร", label: "Dashboard ผู้บริหาร", page: "/300" }] } });
            menuList = [...menuList, ...route1XX, ...route3XX];
        } else if (userRole === "8" || userRole === "9") {
            menuList.unshift({ path: "/", component: P350, exact: true, meta: { breadcrumb: [{ parent: "Dashboard", label: "Dashboard ผู้กรรมการ/ผู้ตรวจสอบ", page: "/350" }] } });
            menuList.push({ path: "/350", component: P350, meta: { breadcrumb: [{ parent: "Dashboard", label: "Dashboard ผู้กรรมการ/ผู้ตรวจสอบ", page: "/350" }] } });

            // new 12/01/2022
            menuList.push({ path: "/220", component: P220, meta: { breadcrumb: [{ parent: "ผู้คุมงาน", label: "ตรวจรับ", page: "/220" }] } });

            menuList = [...menuList, ...route1XX];
        } else if (userRole === "A") {
            menuList.unshift({ path: "/", component: P400, exact: true, meta: { breadcrumb: [{ parent: "ผู้ดูแลระบบ", label: "Dashboard ผู้ดูแลระบบ", page: "/400" }] } });
            menuList = [...menuList, ...route1XX, ...route3XX, ...route4XX];
            if (userBranchCode === "") {
                menuList.push({ path: "/300", component: P300, meta: { breadcrumb: [{ parent: "ผู้บริหาร", label: "Dashboard ผู้บริหาร", page: "/300" }] } });
                menuList = [...menuList, ...route2XX, ...route4XXA];
            }
        }

        setRoutersList(menuList);
    };

    const renderRoute = () => {
        let routersMain = [...routersList];
        return (
            <Switch>
                {routersMain.map((router, index) => {
                    if (router.exact) {
                        return <Route key={`router${index}`} path={router.path} exact component={router.component} />;
                    }
                    return <Route key={`router${index}`} path={router.path} component={router.component} />;
                })}

                <Route component={NotFound} />
            </Switch>
        );
    };

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuModeChange = (e) => {
        setMenuMode(e.value);
        setStaticMenuDesktopInactive(false);
        setOverlayMenuActive(false);

        if (e.value === "horizontal") {
            setProfileMode("popup");
        }
    };

    const onMenuColorChange = (e) => {
        setDarkMenu(e.value);
    };

    const onProfileChange = (e) => {
        setProfileMode(e.value);
    };

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setActiveTopbarItem(null);
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }
            hideOverlayMenu();
        }

        if (!inlineMenuClick && profileMode === "inline" && isSlim() && !isMobile()) {
            setInlineMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        inlineMenuClick = false;
        configClick = false;
        topbarItemClick = false;
        menuClick = false;
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();

            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
    };

    const onMenuClick = () => {
        menuClick = true;

        if (inlineMenuActive && !inlineMenuClick) {
            setInlineMenuActive(false);
        }
    };

    const isMenuVisible = () => {
        if (isDesktop()) {
            if (menuMode === "static") return !staticMenuDesktopInactive;
            else if (menuMode === "overlay") return overlayMenuActive;
            else return true;
        } else {
            return true;
        }
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarMenuActive(false);

        if (isOverlay() && !isMobile()) {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        } else {
            if (isDesktop()) {
                setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
            } else {
                setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
            }
        }

        event.preventDefault();
    };

    const onProfileButtonClick = (event) => {
        setInlineMenuActive((prevInlineMenuActive) => !prevInlineMenuActive);
        inlineMenuClick = true;

        if (isSlim() || isHorizontal()) {
            setMenuActive(false);
        }
    };

    const onTopbarMenuButtonClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevTopbarMenuActive) => !prevTopbarMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarItemClick = (event, item) => {
        topbarItemClick = true;

        if (activeTopbarItem === item) {
            setActiveTopbarItem(null);
        } else {
            setActiveTopbarItem(item);
        }

        event.preventDefault();
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = () => {
        setConfigActive((prevConfigActive) => !prevConfigActive);
        configClick = true;
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 896;
    };

    const isMobile = () => {
        return window.innerWidth <= 896;
    };

    const isOverlay = () => {
        return menuMode === "overlay";
    };

    const isHorizontal = () => {
        return menuMode === "horizontal";
    };

    const isSlim = () => {
        return menuMode === "slim";
    };

    const isStatic = () => {
        return menuMode === "static";
    };

    const hasInlineProfile = profileMode === "inline" && !isHorizontal();

    const containerClassName = classNames("layout-wrapper", {
        "layout-static": isStatic(),
        "layout-overlay": isOverlay(),
        "layout-overlay-active": overlayMenuActive,
        "layout-horizontal": isHorizontal(),
        "layout-slim": isSlim(),
        "layout-static-inactive": staticMenuDesktopInactive,
        "layout-mobile-active": staticMenuMobileActive,
        "layout-menu-dark": darkMenu,
        "layout-menu-light": !darkMenu,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": !ripple,
    });

    const menuContainerClassName = classNames("layout-menu-container", { "layout-menu-container-inactive": !isMenuVisible() });

    return (
        <div className={containerClassName} onClick={onDocumentClick}>
            <AppTopbar topbarMenuActive={topbarMenuActive} activeTopbarItem={activeTopbarItem} onMenuButtonClick={onMenuButtonClick} onTopbarMenuButtonClick={onTopbarMenuButtonClick} onTopbarItemClick={onTopbarItemClick} isHorizontal={isHorizontal()} profileMode={profileMode} isMobile={isMobile} />

            {/* {getSession("login") != undefined && getSession("login").accessToken != undefined && getSession("login").accessToken != '' && getSession("login").accessToken != null ? */}
            {/* <div className={menuContainerClassName} onClick={onMenuClick}>
                <div className="layout-menu-logo">
                    <button className="p-link" onClick={() => history.push("/")}>
                        <img id="layout-menu-logo" src="assets/layout/images/logo-white.png" library="babylon-layout" alt="babylon-logo" />
                    </button>
                </div>
                <div className="layout-menu-wrapper">
                    <div className="menu-scroll-content">
                        {hasInlineProfile && <AppInlineProfile inlineMenuActive={inlineMenuActive} onProfileButtonClick={onProfileButtonClick} />}
                        <AppMenu model={menu} menuMode={menuMode} active={menuActive} onMenuitemClick={onMenuitemClick} onRootMenuitemClick={onRootMenuitemClick} />
                    </div>
                </div>
            </div> */}
            {/* :''} */}

            <div className="layout-main" style={{ paddingTop: "auto" }}>
                <AppBreadcrumb routers={[...routersList]} />

                <div className="layout-content">{renderRoute()}</div>

                <AppFooter />
            </div>

            {/*
                //Config template
                <AppConfig
                configActive={configActive}
                menuMode={menuMode}
                onMenuModeChange={onMenuModeChange}
                isDarkMenu={darkMenu}
                onMenuColorChange={onMenuColorChange}
                profileMode={profileMode}
                onProfileChange={onProfileChange}
                onConfigClick={onConfigClick}
                onConfigButtonClick={onConfigButtonClick}
                rippleActive={ripple}
                onRippleChange={onRippleChange}
                inputStyle={inputStyle}
                onInputStyleChange={onInputStyleChange}
            ></AppConfig> */}

            {staticMenuMobileActive && <div className="layout-mask"></div>}
        </div>
    );
};

export default App;
